export default __webpack_public_path__ + "static/media/sharechat.4ffebf1a.svg";